var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8779 23.1493C18.0828 23.1493 23.1129 18.1192 23.1129 11.9143C23.1129 5.7094 18.0828 0.679321 11.8779 0.679321C5.67296 0.679321 0.642883 5.7094 0.642883 11.9143C0.642883 18.1192 5.67296 23.1493 11.8779 23.1493Z",
    fill: "#26A17B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2275 12.8854V12.884C13.1502 12.8896 12.7521 12.9135 11.8638 12.9135C11.1546 12.9135 10.6554 12.8924 10.4798 12.884V12.8861C7.74971 12.766 5.71196 12.2906 5.71196 11.7219C5.71196 11.1538 7.74971 10.6784 10.4798 10.5562V12.4128C10.6582 12.4255 11.1694 12.4557 11.8758 12.4557C12.7233 12.4557 13.1481 12.4206 13.2275 12.4135V10.5576C15.952 10.6791 17.9848 11.1545 17.9848 11.7219C17.9848 12.2906 15.952 12.7646 13.2275 12.8854ZM13.2275 10.3645V8.70317H17.0291V6.16968H6.67817V8.70317H10.4798V10.3638C7.39019 10.5057 5.06665 11.118 5.06665 11.8511C5.06665 12.5842 7.39019 13.1958 10.4798 13.3383V18.6623H13.2275V13.3369C16.3122 13.1951 18.6301 12.5835 18.6301 11.8511C18.6301 11.1187 16.3122 10.5071 13.2275 10.3645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.84f65b5a1992134e4588176c0a73276c.svg";
export { ForwardRef as ReactComponent };